'use strict';

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-accordion]').each(function() {
    var $el = $(this);

    var isGroup = $el.data('swAccordion') === 'group';
    
    require(['js/lib/views/Accordion'], function(Accordion) {
      new Accordion({
        el: $el,
        isGroup: isGroup
      });
    });
    
  });

};
